import {
  EMPLOYEE,
  EMPLOYEE_ADD,
  EMPLOYEE_EDIT,
  EMPLOYEE_VIEW,
  EMPLOYEE_USER_MAPPING,
  HRM,
  INCREMENT,
  PROMOTION,
  SEPARATION,
  LOAN_ADVANCE,
  APPRAISAL,
  MY_PAYSLIPS,
  ALL_PAYSLIPS,
  ALL_TAX_CERT,
  PAYSLIP_DETAIL,
  PAYROLL_RUNS,
} from '@constants/internal-route.constant'
import {IAppRoutes} from '@interface/common.interface'
import {guard} from './route-guard'

export const HrmRoutes: IAppRoutes = {
  link: HRM,
  childrens: [
    {
      link: EMPLOYEE,
      element: guard(() => import('@modules/hrm/Employee'), [EMPLOYEE]),
    },
    {
      // add/edit are part of the Employee feature: adding needs its Create, editing its Update
      link: EMPLOYEE_ADD,
      element: guard(() => import('@modules/hrm/Employee/Form'), [EMPLOYEE], 'create'),
    },
    {
      link: EMPLOYEE_EDIT({id: ':id'}),
      element: guard(() => import('@modules/hrm/Employee/Form'), [EMPLOYEE], 'update'),
    },
    {
      // read-only detail view — part of the Employee feature
      link: EMPLOYEE_VIEW({id: ':id'}),
      element: guard(() => import('@modules/hrm/Employee/View'), [EMPLOYEE]),
    },
    {
      link: EMPLOYEE_USER_MAPPING,
      element: guard(() => import('@modules/hrm/emp-usr-map'), [EMPLOYEE_USER_MAPPING]),
    },
    {
      link: INCREMENT,
      element: guard(() => import('@modules/hrm/increment'), [INCREMENT]),
    },
    {
      link: PROMOTION,
      element: guard(() => import('@modules/hrm/promotion'), [PROMOTION]),
    },
    {
      link: SEPARATION,
      element: guard(() => import('@modules/hrm/separation'), [SEPARATION]),
    },
    {
      link: LOAN_ADVANCE,
      element: guard(() => import('@modules/hrm/loan-advance'), [LOAN_ADVANCE]),
    },
    {
      // Company-wide payslip register (admin) — all employees' payslips across runs.
      link: ALL_PAYSLIPS,
      element: guard(() => import('@modules/hrm/all-payslips'), [ALL_PAYSLIPS]),
    },
    {
      // Single-payslip detail drill-in (reached from My/All Payslips + Run Detail).
      // Stays under /hrm — shared by ESS "My Payslips" and admin "All Payslips".
      link: PAYSLIP_DETAIL({id: ':id'}),
      // All Payslips and the Employee view link here too; the server confines a caller without
      // those grants to their own payslip.
      element: guard(() => import('@modules/hrm/payslip'), [PAYROLL_RUNS, MY_PAYSLIPS, ALL_PAYSLIPS, EMPLOYEE]),
    },
    {
      // Company-wide tax-certificate register (admin) — the All-Payslips sibling.
      link: ALL_TAX_CERT,
      element: guard(() => import('@modules/hrm/all-tax-certificate'), [ALL_TAX_CERT]),
    },
    {
      // Appraisals — moved from the KPI/Performance menu into Employee.
      link: APPRAISAL,
      element: guard(() => import('@modules/appraisal'), [APPRAISAL]),
    },
  ],
}
